/* tslint:disable */
/* eslint-disable */
/**
 * MachineGo P1 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface TimeSpan
 */
export interface TimeSpan {
    /**
     * 
     * @type {number}
     * @memberof TimeSpan
     */
    ticks?: number;
    /**
     * 
     * @type {number}
     * @memberof TimeSpan
     */
    days?: number;
    /**
     * 
     * @type {number}
     * @memberof TimeSpan
     */
    hours?: number;
    /**
     * 
     * @type {number}
     * @memberof TimeSpan
     */
    milliseconds?: number;
    /**
     * 
     * @type {number}
     * @memberof TimeSpan
     */
    microseconds?: number;
    /**
     * 
     * @type {number}
     * @memberof TimeSpan
     */
    readonly nanoseconds?: number;
    /**
     * 
     * @type {number}
     * @memberof TimeSpan
     */
    minutes?: number;
    /**
     * 
     * @type {number}
     * @memberof TimeSpan
     */
    seconds?: number;
    /**
     * 
     * @type {number}
     * @memberof TimeSpan
     */
    readonly totalDays?: number;
    /**
     * 
     * @type {number}
     * @memberof TimeSpan
     */
    readonly totalHours?: number;
    /**
     * 
     * @type {number}
     * @memberof TimeSpan
     */
    readonly totalMilliseconds?: number;
    /**
     * 
     * @type {number}
     * @memberof TimeSpan
     */
    readonly totalMicroseconds?: number;
    /**
     * 
     * @type {number}
     * @memberof TimeSpan
     */
    readonly totalNanoseconds?: number;
    /**
     * 
     * @type {number}
     * @memberof TimeSpan
     */
    readonly totalMinutes?: number;
    /**
     * 
     * @type {number}
     * @memberof TimeSpan
     */
    readonly totalSeconds?: number;
}

export function TimeSpanFromJSON(json: any): TimeSpan {
    return TimeSpanFromJSONTyped(json, false);
}

export function TimeSpanFromJSONTyped(json: any, ignoreDiscriminator: boolean): TimeSpan {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'ticks': !exists(json, 'ticks') ? undefined : json['ticks'],
        'days': !exists(json, 'days') ? undefined : json['days'],
        'hours': !exists(json, 'hours') ? undefined : json['hours'],
        'milliseconds': !exists(json, 'milliseconds') ? undefined : json['milliseconds'],
        'microseconds': !exists(json, 'microseconds') ? undefined : json['microseconds'],
        'nanoseconds': !exists(json, 'nanoseconds') ? undefined : json['nanoseconds'],
        'minutes': !exists(json, 'minutes') ? undefined : json['minutes'],
        'seconds': !exists(json, 'seconds') ? undefined : json['seconds'],
        'totalDays': !exists(json, 'totalDays') ? undefined : json['totalDays'],
        'totalHours': !exists(json, 'totalHours') ? undefined : json['totalHours'],
        'totalMilliseconds': !exists(json, 'totalMilliseconds') ? undefined : json['totalMilliseconds'],
        'totalMicroseconds': !exists(json, 'totalMicroseconds') ? undefined : json['totalMicroseconds'],
        'totalNanoseconds': !exists(json, 'totalNanoseconds') ? undefined : json['totalNanoseconds'],
        'totalMinutes': !exists(json, 'totalMinutes') ? undefined : json['totalMinutes'],
        'totalSeconds': !exists(json, 'totalSeconds') ? undefined : json['totalSeconds'],
    };
}

export function TimeSpanToJSON(value?: TimeSpan | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'ticks': value.ticks,
        'days': value.days,
        'hours': value.hours,
        'milliseconds': value.milliseconds,
        'microseconds': value.microseconds,
        'minutes': value.minutes,
        'seconds': value.seconds,
    };
}

